import { Injectable } from '@angular/core';
import { Connection, hubConnection, Proxy } from 'signalr-no-jquery';
import { EventService, HRIMServerEvents } from './event.service';
import { NotificationsService } from './notifications.service';
import { AccountService } from '../../pages/account/services/account.service';

@Injectable({
  providedIn: 'root',
})
export class AngularSignalRService {
  private connection: Connection;
  private proxyHub: Proxy;
  private eventName: string[];
  private ServerEvents: Map<string, string> = this.objToMap(HRIMServerEvents);
  constructor(
    private eventService: EventService,
    private notificationsService: NotificationsService,
    private accountService: AccountService
  ) {}

  public async establishHub(proxyhubname: string) {
    const isLoggedIn = await this.accountService.GetIsLoggedIn();
    if (!isLoggedIn) {
      // it's ok to never connect when the user isn't logged in
      // upon login the angular app will restart and this value will be re-evaluated
      return;
    }
    this.connection = hubConnection();
    this.proxyHub = this.connection.createHubProxy(proxyhubname);
    this.eventName = this.mapKeys(this.ServerEvents);
    this.registerOnServerEvents();
    this.startConnection();
    this.RegisterReConnect();
  }

  public stopConnection(): void {
    if (this.connection) {
      this.connection.stop();
      this.connection = undefined;
    }
  }

  private startConnection(): void {
    this.connection.start().fail((error: any) => this.notificationsService.log(`Could not connect: ${error}`, 'signalR'));
  }

  //Mozilla SignalR disconnection issue
  private RegisterReConnect(): void {
    if (!navigator.onLine) return;

    this.connection.disconnected(() => this.DisconnectedCallback());
  }

  private DisconnectedCallback(): void {
    //try to reconnect every 10 seconds, not the best solution but much better than before
    setInterval(() => this.AttemptReconnect(), 10000);
  }

  private AttemptReconnect(): void {
    if (!navigator.onLine) return;

    if (!this.connection) return;

    this.connection.start().done(() => this.registerOnServerEvents());
  }

  private registerOnServerEvents(): void {
    this.eventName.forEach((event: string) => {
      this.proxyHub.off(event);
      this.proxyHub.on(event, (messageData: any) => setTimeout(() => this.emitLocalEvent(event, messageData), 0));
    });
  }

  private emitLocalEvent(event: string, messageData: any): void {
    const sr_event = this.ServerEvents.get(event);
    if (!sr_event) return;

    this.eventService.broadcast(sr_event, messageData);
  }

  // would love for this method to be in utility service, but it's not available here
  public objToMap(theObject: object): Map<string, string> {
    const map = new Map<string, string>();
    for (const key in theObject) {
      //TypeScript does not allow enum keys to be numeric
      if (!isNaN(Number(key))) continue;

      const val = theObject[key] as string;

      //TypeScript does not allow enum value to be null or undefined
      if (val !== undefined && val !== null) map.set(key, val);
    }

    return map;
  }

  // would love for this method to be in utility service, but it's not available here
  public mapKeys(map: Map<string, string>): string[] {
    return Array.from(map.keys());
  }
}
